<template>
  <ButtonSquare
    :title="$t('general__view__mapview')"
    :imgSource="iconMaps"
    size="large"
    @clicked="handleClick"
  />
</template>

<script setup lang="ts">
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import iconMaps from '@/assets/icon-maps.svg'

const emit = defineEmits(['mapviewButtonClick'])

function handleClick() {
  // Needed to move logic to ViewButtons.vue because of joint view related v-if for viewbuttons
  emit('mapviewButtonClick')
}
</script>
